import { render, staticRenderFns } from "./HomeDatabase.vue?vue&type=template&id=7381c471&scoped=true"
import script from "./HomeDatabase.vue?vue&type=script&lang=js"
export * from "./HomeDatabase.vue?vue&type=script&lang=js"
import style0 from "./HomeDatabase.vue?vue&type=style&index=0&id=7381c471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381c471",
  null
  
)

export default component.exports